import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MetadataContentTabs } from '../../ui-parts/MetadataContentTabs';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { MyMModal } from '../../ui-elements/MyMModal';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { useLocation } from 'react-router-dom';


/** MyMine Version12.0 AHSLv1画面新規追加
* AHSLv1 Page Content
*/
export const AHSLv1 = () => {
  const LayerInfoPanel = (props) => {
    const { index } = props;
    return (
      <Grid item xs={12} md={12} lg={4}>
        {controlSettings.ImageList['imgLayerInfoHeaderIcon' + index] ?
          <Box sx={{
            padding: '10px',
            border: '2px solid #D4D4D4',
            borderRadius: '5px',
            height: '100%',
            overflowY: 'auto',
          }}>
            <Grid container>
              <Grid item xs={5}>
                {
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList['imgLayerInfoHeaderIcon' + index]}
                    alt='LayerInfoIcon'
                    height='auto'
                    display='block'
                  />
                }
              </Grid>
              <Grid item xs={7} sx={{
                display: 'flex',
                alignItems: 'center',
              }} >
                <MyMLabel fontSize='20px'>{controlSettings.LabelList['lblLayerInfoHeader' + index]}</MyMLabel>
              </Grid>
            </Grid>
            {index === 4 && controlSettings.LabelList.lblRSTOPText && (
              <>
                <MyMLabel
                  fontSize='5px'
                  sx={{
                    paddingLeft: '40px',
                    fontSize: '20px !important',
                  }}
                >
                  {controlSettings.LabelList.lblLayerInfoMobileLayerDescription2}
                </MyMLabel>
                <br />
                <MyMLabel
                  fontSize='20px'
                  sx={{
                    paddingLeft: '40px',
                    fontWeight: 'bold',
                    fontSize: '20px !important',
                  }}
                >
                  {controlSettings.LabelList.lblLayerInfoMobileLayerDescription}
                </MyMLabel>

              </>
            )}

            <MyMLabel fontSize='20px' sx={{ margin: '10px 20px' }}>{controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text1']}</MyMLabel>


            {
              controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`] ?
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`]}
                  alt='LayerInfDescription1'
                  height='auto'
                  width='100%'
                  display='block'
                  style={{ margin: '10px 0' }}
                /> : null
            }

            {controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2'] && (
              <>
                <MyMLabel
                  fontSize='20px'
                  sx={{
                    paddingLeft: '50px',
                    fontWeight: 'bold',
                    fontSize: '20px !important',
                  }}
                >
                  {controlSettings.LabelList.lblLayerInfoDescription4TextTop2}
                </MyMLabel>
                <MyMLabel sx={{ margin: '10px 0' }}>
                  {controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2']}
                </MyMLabel>
              </>
            )}

            {
              controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`] ?
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`]}
                  alt='LayerInfDescription2'
                  height='auto'
                  width='100%'
                  display='block'
                  style={{ margin: '10px 0' }}
                /> : null
            }
          </Box>
          : null
        }
      </Grid >
    );
  }

  const SmartphoneLayerInfoPanel = (props) => {
    const { index } = props;

    return (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {controlSettings.ImageList['imgLayerInfoHeaderIcon' + index] ? (
          <Box sx={{
            padding: '10px',
            border: '2px solid #D4D4D4',
            borderRadius: '5px',
            height: '350px',
            width: '100%',
            overflowY: 'auto',
          }}>
            <Grid container spacing={1}>
              <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList['imgLayerInfoHeaderIcon' + index]}
                  alt='LayerInfoIcon'
                  height='auto'
                  width='100%'
                  display='block'
                />
              </Grid>
              <Grid item xs={9} sx={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '10px',
              }}>
                <MyMLabel fontSize='16px'>{controlSettings.LabelList['lblLayerInfoHeader' + index]}</MyMLabel>
              </Grid>
            </Grid>
            {index === 4 && controlSettings.LabelList.lblRSTOPText && (
              <>
                <MyMLabel
                  paddingLeft='20px'
                  fontSize='15px'
                  sx={{
                    fontWeight: 'bold',
                  }}
                >
                  {controlSettings.LabelList.lblLayerInfoDescription4TextTop1}
                </MyMLabel>
              </>
            )}
            <MyMLabel sx={{ margin: '10px 0', fontSize: '14px' }}>
              {controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text1_Mobile']}
            </MyMLabel>


            {controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`] && (
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`]}
                alt='LayerInfDescription1'
                height='auto'
                width='100%'
                display='block'
                sx={{ margin: '10px 0' }}
              />
            )}

            {controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2'] && (
              <>
                <MyMLabel
                  fontSize='15px'
                  sx={{
                    paddingLeft: '20px',
                    paddingTop: '5px',
                    fontWeight: 'bold',
                  }}
                >
                  {controlSettings.LabelList.lblLayerInfoDescription4TextTop2}
                </MyMLabel>
                <MyMLabel sx={{ margin: '10px 0' }}>
                  {controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2_Mobile']}
                </MyMLabel>
              </>
            )}



            {controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`] && (
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`]}
                alt='LayerInfDescription2'
                height='auto'
                width='100%'
                display='block'
                sx={{ margin: '10px 0' }}
              />
            )}
          </Box>
        ) : null}
      </Grid>
    );
  };
  const screenId = 'MyM313';
  const { controlSettings, screenSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const [content, setContent] = useState(null);
  const isPc = useMediaQuery('(min-width:1200px)');
  // 2026.2.25 タブレット表示時対応 Add Start
  const isMobile = useMediaQuery('(min-width:600px)');
  // 2026.2.25 タブレット表示時対応 Add End
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const location = useLocation();
  // 2025.3.5 MyMine Version2.1対応 Add End
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setIsInitLoading(true);
    /**
    * Contents情報取得成功時処理
    * @param {any} result
    */

    const callbackSuccessRequestServiceContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestServiceContents();
        return;
      }

      setContent(result);
      setIsInitLoading(false);

      // 2025.3.5 MyMine Version2.1対応 Add Start
      if (location.state?.previewFileId) {
        setTimeout(() => {
          scrollToSection('section-3')
          setPreviewFileId(location.state.previewFileId);
          setIsModalOpen(true);
        }, 10)
      }
      // 2025.3.5 MyMine Version2.1対応 Add End

    }

    /**
    * Contents情報取得失敗時処理
    */
    const callbackFailedRequestServiceContents = () => {
      setIsInitLoading(false);
    }

    apiRequest.requestJson('api/ahs/lv1', 'GET', callbackSuccessRequestServiceContents, callbackFailedRequestServiceContents);
  }
    , [])



  if (content == null)
    return <MyMProgress />

  return (
    <Box className='py-1'>
      {isInitLoading && <MyMProgress />}
      {isPc ? (
        <>
          {/*Title*/}
          <Box sx={{ paddingBottom: '20px' }}>
            <MyMVariantLabel variant='h5' sx={{ fontSize: '28px' }}>{controlSettings.LabelList.lblAhsLv1Title}</MyMVariantLabel>
            <MyMLabel fontSize='20px'>{controlSettings.LabelList.lblAhsLv1Massage}</MyMLabel>
          </Box>

          {/*Header,Description アンカーボタン*/}
          <Grid container className='mt-2' sx={{ justifyContent: 'center', alignItems: 'center' }} >
            <Grid item xs={1.5} />
            <Grid item>
              <Grid sx={{ paddingLeft: '160px' }}>
                <Grid container >
                  <Grid item xs={5}>
                    <MyMImage
                      screenId={screenId}
                      filePath={controlSettings.ImageList.imgAhsTop}
                      alt='AhsTop'
                      height='auto'
                      width='94%'
                      display='block'
                    />
                  </Grid>
                  <Grid item xs={6} sx={{ marginTop: '30px' }}>
                    <Grid item xs={12}>
                      <MyMLabel fontSize='28px' fontWeight='bold' sx={{ paddingBottom: '26px' }}>{controlSettings.LabelList.lblAhsHeader}</MyMLabel>
                    </Grid>
                    <Grid item xs={12} md={10} lg={1.0} />
                    <Grid item xs={11} sx={{ textAlign: 'left' }}>
                      <MyMLabel fontSize='20px' sx={{ lineHeight: 2 }}>{controlSettings.LabelList.lblAhsDescription}</MyMLabel>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/*ボタン*/}
              <Grid container className='mt-2' sx={{ padding: '3% 8%', justifyContent: 'center', alignItems: 'center' }}>
                {/*WhatisAHSボタン*/}
                <Grid item xs={10} md={12} lg={4} sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '10px',

                }}>
                  <MyMBlackLink
                    sx={{
                      display: 'block',
                      width: '300px',
                      height: '70px',
                      color: 'white',
                    }}
                    onClick={() => scrollToSection('section-1')}
                  >
                    <Box sx={{
                      height: '70px',
                      width: '300px',
                      backgroundColor: '#7F7F7F',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px'
                    }}>
                      <MyMLabel fontSize='1.5rem' sx={{ color: 'white' }}>{controlSettings.LabelList.lnkWhatIsAhsPanel}</MyMLabel>
                    </Box>
                  </MyMBlackLink>
                </Grid>
                {/*AHS Materialsボタン */}
                <Grid item xs={12} md={12} lg={4} sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}>
                  <MyMBlackLink
                    sx={{
                      display: 'block',
                      width: '300px',
                      height: '70px',
                      color: 'white'
                    }}
                    onClick={() => scrollToSection('section-2')}
                  >
                    <Box sx={{
                      height: '70px',
                      width: '300px',
                      backgroundColor: '#7F7F7F',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px'
                    }}>
                      <MyMLabel fontSize='1.5rem' sx={{ color: 'white' }}>{content.ModelMetadataName ?? content.MetadataCategoryName}</MyMLabel>
                    </Box>
                  </MyMBlackLink>
                </Grid>
              </Grid>
            </Grid>
            <Box>
              {/*WhatisAHS*/}
              <Box id='section-1' sx={{ paddingLeft: '160px' }}>
                <Box sx={{ paddingTop: '25px' }}>
                  <MyMVariantLabel variant='h5' sx={{ fontSize: '50px', fontWeight: 'bold' }}>{controlSettings.LabelList.lblWhatIsAhsTitle}</MyMVariantLabel>
                </Box>
                <Grid container className='mt-4' >
                  <Grid item xs={1} />
                  <Grid item xs={12} >
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={12} lg={5.5} >
                        <MyMImage
                          screenId={screenId}
                          filePath={controlSettings.ImageList.imgWhatIsAhs}
                          alt='WhatIsAhs'
                          height='auto'
                          width='100%'
                          display='block'
                        />
                      </Grid >
                      <Grid item xs={12} md={12} lg={5.5} sx={{ marginTop: '35px' }} >
                        <Box sx={{
                          padding: '5px',
                          paddingLeft: '40px',
                          height: '100%',
                        }}>
                          <MyMLabel fontSize='20px'>
                            {controlSettings.LabelList.lblWhatIsAhsText}
                          </MyMLabel>
                          <Box sx={{
                            height: '70px',
                            width: '97%',
                            backgroundColor: '#7F7F7F',
                            display: 'flex',
                            justifyContent: 'left',
                            alignItems: 'center',
                            borderRadius: '10px',
                            marginTop: '20px'
                          }}>
                            <MyMLabel fontSize='20px' sx={{ color: 'white', marginLeft: '10px' }}>{controlSettings.LabelList.lblWhatIsAhs_subText1}</MyMLabel>
                          </Box>
                          <Box sx={{
                            height: '70px',
                            width: '97%',
                            backgroundColor: '#7F7F7F',
                            display: 'flex',
                            justifyContent: 'left',
                            alignItems: 'center',
                            borderRadius: '10px',
                            marginTop: '20px'
                          }}>
                            <MyMLabel fontSize='20px' sx={{ color: 'white', marginLeft: '10px' }}>{controlSettings.LabelList.lblWhatIsAhs_subText2}</MyMLabel>
                          </Box>
                          <Box sx={{
                            height: '70px',
                            width: '97%',
                            backgroundColor: '#7F7F7F',
                            display: 'flex',
                            justifyContent: 'left',
                            alignItems: 'center',
                            borderRadius: '10px',
                            marginTop: '20px'
                          }}>
                            <MyMLabel fontSize='20px' sx={{ color: 'white', marginLeft: '10px' }}>{controlSettings.LabelList.lblWhatIsAhs_subText3}</MyMLabel>
                          </Box>
                        </Box>
                      </Grid >
                    </Grid >
                    <Grid container spacing={4} sx={{ marginBottom: '20px' }}>
                      <Grid item xs={12} md={12} >
                        <Box sx={{
                          paddingTop: '60px',
                          height: '100%',
                          marginRight: '10px'
                        }}>
                          <MyMLabel fontSize='20px' >{controlSettings.LabelList.lblTechInfoAhs}</MyMLabel>
                        </Box>
                      </Grid >
                    </Grid >
                    <Grid item xs={12} md={12} lg={10} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '40px' }}>
                      <MyMImage
                        screenId={screenId}
                        filePath={controlSettings.ImageList.imgTechInfoAhs}
                        alt='TechInfoAhs'
                        height='auto'
                        width='70%'
                        display='block'
                      />
                    </Grid >
                    <Grid container spacing={2} sx={{ marginTop: '30px', justifyContent: 'center', width: '90%' }}>
                      {[...Array(3)].map((_, i) => {
                        return (
                          <LayerInfoPanel
                            index={i + 1}
                            key={i}
                          />
                        );
                      })}
                      <Grid item xs={12} md={12} lg={12}>
                        {controlSettings.ImageList['imgLayerInfoHeaderIcon4'] ?
                          <Box sx={{
                            padding: '10px',
                            border: '2px solid #D4D4D4',
                            borderRadius: '5px',
                            height: '100%',
                            overflowY: 'auto',
                          }}>
                            <Grid container>
                              <Grid item >
                                {
                                  <MyMImage
                                    screenId={screenId}
                                    filePath={controlSettings.ImageList['imgLayerInfoHeaderIcon4']}
                                    alt='LayerInfoIcon'
                                    height='auto'
                                    display='block'
                                  />
                                }
                              </Grid>
                              <Grid item sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }} >
                                <MyMLabel fontSize='20px'>{controlSettings.LabelList['lblLayerInfoHeader4']}</MyMLabel>
                              </Grid>
                            </Grid>
                            <Grid container sx={{ paddingTop: '20px' }}>
                              <Grid item xs={6}>
                                <Grid >
                                  <MyMLabel
                                    fontSize='20px'
                                    sx={{
                                      paddingLeft: '40px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {controlSettings.LabelList.lblLayerInfoDescription4TextTop1}
                                  </MyMLabel>
                                  <MyMLabel fontSize='20px' sx={{ margin: '10px 20px' }}>{controlSettings.LabelList['lblLayerInfoDescription4Text1']}</MyMLabel>
                                </Grid>
                                <Grid item xs={12}>
                                  <MyMImage
                                    screenId={screenId}
                                    filePath={controlSettings.ImageList[`imgLayerInfoDescription${4}Image1`]}
                                    alt='LayerInfDescription1'
                                    height='auto'
                                    width='100%'
                                    display='block'
                                    style={{ margin: '10px 0' }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid item xs={6}>
                                <Grid>
                                  <MyMLabel
                                    fontSize='20px'
                                    sx={{
                                      fontWeight: 'bold',
                                      paddingLeft: '10px',
                                    }}
                                  >
                                    {controlSettings.LabelList.lblLayerInfoDescription4TextTop2}
                                  </MyMLabel>
                                  <MyMLabel fontSize='20px' sx={{ margin: '10px 0' }}>
                                    {controlSettings.LabelList['lblLayerInfoDescription4Text2']}
                                  </MyMLabel>
                                </Grid>
                                <Grid item xs={12}>
                                  <MyMImage
                                    screenId={screenId}
                                    filePath={controlSettings.ImageList[`imgLayerInfoDescription${4}Image2`]}
                                    alt='LayerInfDescription2'
                                    height='auto'
                                    width='100%'
                                    display='block'
                                    style={{ margin: '10px 0' }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                          : null
                        }
                      </Grid >
                      <Box sx={{ border: '2px solid #D4D4D4', borderRadius: '5px', padding: '10px', marginLeft: '16px', marginTop: '30px' }}>
                        <Grid item xs={12}>
                          <MyMLabel
                            fontSize='20px'
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '20px !important',

                            }}
                          >
                            {controlSettings.LabelList.lblRSTOPText}
                          </MyMLabel>
                          <MyMLabel fontSize='20px' >{controlSettings.LabelList.lblLayerInfoText2}</MyMLabel>
                        </Grid>
                      </Box>
                    </Grid >

                  </Grid >
                  <Grid item xs={1} />

                </Grid >
              </Box>
              {/*ファイルエリア*/}
              <Box className='py-1 d-flex flex-column mb-4' id='section-2' sx={{ paddingLeft: '160px' }}>
                <Box className='mb-4'>
                  <MyMVariantLabel variant='h5' sx={{ paddingTop: '50px', paddingBottom: '20px', fontSize: '50px', fontWeight: 'bold' }}>{content.ModelMetadataName ?? content.MetadataCategoryName}</MyMVariantLabel>
                </Box>
                <Grid container className='pb-2 flex-grow-1' spacing={4}>
                  <Grid item xs={12} md={3} className='d-flex justify-content-center' sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {controlSettings.ImageList.imgAhsFileArea && (
                      <Box
                        sx={{
                          '& img': {
                            height: 'auto',
                            objectFit: 'contain',
                          },
                          // ～899px
                          '@media (max-width:899.98px)': {
                            '& img': { width: '100%', maxWidth: '100%' },
                          },
                          // 900～1750px
                          '@media (min-width:900px) and (max-width:1750px)': {
                            '& img': { width: '340px', maxWidth: '340px' },
                          },
                          // 1750px 
                          '@media (min-width:1750px)': {
                            '& img': { width: '400px', maxWidth: '400px' },
                          },
                        }}
                      >
                        <MyMImage
                          screenId={screenId}
                          filePath={controlSettings.ImageList.imgAhsFileArea}
                          alt="AhsFileArea"
                        />
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={12} md={8.7} lg={7.7} id='section-3'>
                    <MetadataContentTabs
                      screenId={screenId}
                      metadataContent={content}
                      setIsLoading={setIsInitLoading}
                      // 2025.3.5 MyMine Version2.1対応 Add Start
                      canShareContents={true}
                      contentsShareParameter={location.state}
                      // 2025.3.5 MyMine Version2.1対応 Add End
                      //2025.7.7 Version3.0対応 Add Start
                      isAhsMetadataContentTabs={true}
                      //2025.7.7 Version3.0対応 Add End
                    />
                  </Grid>
                </Grid>
              </Box>
              
            </Box>
          </Grid>


          {/*Cntact*/}
          <Box>
            <MyMLabel fontSize='22px' sx={{ fontWeight: '500', textAlign: 'center', paddingTop: '50px' }}>{controlSettings.LabelList.lblAhsContact}</MyMLabel>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <Link sx={{ width: 'fit-content', display: 'block', fontSize: '20px', textAlign: 'center' }} href={"mailto:" + screenSettings.ContactAddress} >
                {screenSettings.ContactAddress}
              </Link>
            </Box>
          </Box>

          <Grid item xs={1.5} />
        </>)
        :
        /*スマホ・タブレット版対応*/
        (<>

          {/* Title */}
          <Box>
            <MyMVariantLabel variant='h5' sx={{ fontSize: '24px', textAlign: 'left' }}>
              {controlSettings.LabelList.lblAhsLv1Title}
            </MyMVariantLabel>
            <MyMLabel sx={{ textAlign: 'left' }}>
              {controlSettings.LabelList.lblAhsLv1Massage}
            </MyMLabel>
          </Box>


          {/* Header, Description アンカーボタン */}
          <Grid container className='mt-2' sx={{ justifyContent: 'center', alignItems: 'center', px: 0, mx: 0, width: '100%' }}>
            <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 1.5, sm: 2 }, width: '100%' }}>
              <Grid item xs={12} sx={{ textAlign: 'left', px: 0 }}>
                <Grid container spacing={0} sx={{ justifyContent: 'center', px: 0, mx: 0, width: '100%' }}>
                  <Grid item xs={12} sm={6} md={5} sx={{ px: 0 }}>
                    <MyMImage
                      screenId={screenId}
                      filePath={controlSettings.ImageList.imgAhsTop}
                      alt='AhsTop'
                      height='auto'
                      width='100%'
                      display='block'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={7} sx={{ px: 0 }}>
                    <MyMLabel fontSize={'22px'} fontWeight='bold' sx={{ pb: '16px', textAlign: 'center' }}>
                      {controlSettings.LabelList.lblAhsHeader}
                    </MyMLabel>
                    <MyMLabel fontSize='18px' sx={{ lineHeight: 1.8, textAlign: 'center' }}>
                      {controlSettings.LabelList.lblAhsDescription}
                    </MyMLabel>
                  </Grid>
                </Grid>
                <Grid container className='mt-2' sx={{ justifyContent: 'center', px: 0, py: 0, mx: 0, width: '100%' }}>
                  {/* WhatisAHS ボタン */}
                  <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center', mb: '10px', px: 0 }}>
                    <MyMBlackLink
                      sx={{
                        display: 'block',
                        width: '90%',
                        maxWidth: 480,
                        height: '60px',
                        color: 'white',
                      }}
                      onClick={() => scrollToSection('section-1')}
                    >
                      <Box sx={{ height: '60px', backgroundColor: '#7F7F7F', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}>
                        <MyMLabel fontSize='1.2rem' sx={{ color: 'white' }}>
                          {controlSettings.LabelList.lnkWhatIsAhsPanel}
                        </MyMLabel>
                      </Box>
                    </MyMBlackLink>
                  </Grid>

                  {/* AHS Materials ボタン */}
                  <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center', mb: '10px', px: 0 }}>
                    <MyMBlackLink
                      sx={{
                        display: 'block',
                        width: '90%',
                        maxWidth: 480,
                        height: '60px',
                        color: 'white',
                      }}
                      onClick={() => scrollToSection('section-2')}
                    >
                      <Box sx={{ height: '60px', backgroundColor: '#7F7F7F', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}>
                        <MyMLabel fontSize='1.2rem' sx={{ color: 'white' }}>
                          {content.ModelMetadataName ?? content.MetadataCategoryName}
                        </MyMLabel>
                      </Box>
                    </MyMBlackLink>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* WhatisAHS セクション */}
          <Box id='section-1' sx={{ px: 0, pt: '20px', mx: 0, width: '100%' }}>
            <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 1.5, sm: 2 }, width: '100%' }}>
              <MyMVariantLabel variant='h5' sx={{ fontSize: '30px', fontWeight: 'bold', textAlign: 'center' }}>
                {controlSettings.LabelList.lblWhatIsAhsTitle}
              </MyMVariantLabel>

              <Grid container spacing={0} sx={{ justifyContent: 'center', px: 0, mx: 0, width: '100%' }}>
                <Grid item xs={12} sm={6} sx={{ px: 0 }}>
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList.imgWhatIsAhs}
                    alt='WhatIsAhs'
                    height='auto'
                    width='100%'
                    display='block'
                  />
                </Grid>

                <Grid item xs={12} sm={6} sx={{ px: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Box sx={{ p: 0, textAlign: 'center' }}>
                    <MyMLabel fontSize='18px'>{controlSettings.LabelList.lblWhatIsAhsText_Mobile}</MyMLabel>
                  </Box>

                  {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                  {/* 1つ目 */}
                  <Box
                    sx={{
                      height: 70,
                      width: { xs: '100%', sm: isMobile ? '80%' : '60%' },
                      mx: 'auto',
                      backgroundColor: '#7F7F7F',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      mt: '16px',
                    }}
                  >
                    <MyMLabel fontSize="18px" sx={{ color: 'white' }}>
                      {controlSettings.LabelList.lblWhatIsAhs_subText1_Mobile}
                    </MyMLabel>
                  </Box>

                  {/* 2つ目 */}
                  <Box
                    sx={{
                      height: 70,
                      width: { xs: '100%', sm: isMobile ? '80%' : '60%' },
                      mx: 'auto',
                      backgroundColor: '#7F7F7F',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      mt: '12px',
                    }}
                  >
                    <MyMLabel fontSize="18px" sx={{ color: 'white' }}>
                      {controlSettings.LabelList.lblWhatIsAhs_subText2_Mobile}
                    </MyMLabel>
                  </Box>

                  {/* 3つ目 */}
                  <Box
                    sx={{
                      height: 70,
                      width: { xs: '100%', sm: isMobile ? '80%' : '60%' },
                      mx: 'auto',
                      backgroundColor: '#7F7F7F',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '10px',
                      mt: '12px',
                    }}
                  >
                    <MyMLabel fontSize="18px" sx={{ color: 'white' }}>
                      {controlSettings.LabelList.lblWhatIsAhs_subText3}
                    </MyMLabel>
                  </Box>
                  {/* 2026.2.25 タブレット表示時対応 Modify End */}
                </Grid>
              </Grid>

              <Box sx={{ height: 30 }} />

              <Grid container spacing={0} sx={{ mt: '16px', justifyContent: 'center', px: 0, mx: 0, width: '100%' }}>
                <Grid item xs={12} sm={6} sx={{ px: 0 }}>
                  <Box sx={{ p: 0, height: '100%', textAlign: 'center' }}>
                    <MyMLabel fontSize='16px'>{controlSettings.LabelList.lblTechInfoAhs_Mobile}</MyMLabel>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ px: 0 }}>
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList.imgTechInfoAhs}
                    alt='TechInfoAhs'
                    height='auto'
                    width='100%'
                    display='block'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={0} sx={{ mt: '16px', px: 0, mx: 0, width: '100%' }}>
                {[...Array(8)].map((_, i) => {
                  return (
                    <Grid item xs={12} sm={6} md={12} key={i} sx={{ px: 0 }}>
                      <SmartphoneLayerInfoPanel index={i + 1} />
                    </Grid>
                  );
                })}
              </Grid>

              <Box sx={{ border: '2px solid #D4D4D4', borderRadius: '5px', p: '15px', width: '100%', mt: '12px' }}>
                <Grid item xs={12}>
                  <MyMLabel
                    fontSize='20px'
                    sx={{ fontWeight: 'bold', textAlign: 'center' }}
                  >
                    {controlSettings.LabelList.lblRSTOPText}
                  </MyMLabel>
                  <MyMLabel fontSize='16px' sx={{ textAlign: 'center' }}>{controlSettings.LabelList.lblLayerInfoText2}</MyMLabel>
                </Grid>
              </Box>
            </Box>
          </Box>



          {/* ファイルエリア */}
          <Box className='py-1 d-flex flex-column mb-4' id='section-2' sx={{ paddingLeft: '20px', marginTop: '40px' }}>
            <MyMVariantLabel variant='h5' sx={{ fontSize: '30px', fontWeight: 'bold', textAlign: 'center' }}>
              {content.ModelMetadataName ?? content.MetadataCategoryName}
            </MyMVariantLabel>
            <Grid container className='pb-2 flex-grow-1'>
              <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                {controlSettings.ImageList.imgAhsFileArea && (
                  <Box
                    sx={{
                      '& img': {
                        height: 'auto',
                        objectFit: 'contain',
                      },
                      // ～899px：
                      '@media (max-width:899.98px)': {
                        '& img': { width: '100%', maxWidth: '100%' },
                      },
                      // 900～1750px
                      '@media (min-width:900px) and (max-width:1750px)': {
                        '& img': { width: '220px', maxWidth: '220px' },
                      },
                      // 1750px
                      '@media (min-width:1750px)': {
                        '& img': { width: '200px', maxWidth: '200px' },
                      },
                    }}
                  >
                    <MyMImage
                      screenId={screenId}
                      filePath={controlSettings.ImageList.imgAhsFileArea}
                      alt="AhsFileArea"
                    />
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={8.7} id = 'section-3'>
                <MetadataContentTabs
                  screenId={screenId}
                  metadataContent={content}
                  setIsLoading={setIsInitLoading}
                  // 2025.3.5 MyMine Version2.1対応 Add Start
                  canShareContents={true}
                  contentsShareParameter={location.state}
                  // 2025.3.5 MyMine Version2.1対応 Add End
                  //2025.7.7 Version3.0対応 Add Start
                  isAhsMetadataContentTabs={true}
                  //2025.7.7 Version3.0対応 Add End
                />
              </Grid>
            </Grid>
          </Box>

          {/* Contact */}
          <Box sx={{ textAlign: 'center', paddingTop: '30px' }}>
            <MyMLabel fontSize={'18px'}>
              {controlSettings.LabelList.lblAhsContact}
            </MyMLabel>
            <Box sx={{ marginBottom: '15px' }}>
              <Link sx={{ display: 'block', fontSize: '20px', textAlign: 'center' }} href={"mailto:" + screenSettings.ContactAddress} >
                {screenSettings.ContactAddress}
              </Link>
            </Box>
          </Box>
          
        </>
        )
      }
      {/* 2025.3.5 MyMine Version2.1対応 Add Start */}
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
      {/* 2025.3.5 MyMine Version2.1対応 Add End */}
    </Box>

  );
}

export default AHSLv1;